module.exports = __webpack_public_path__ + "media/images/svg-sprite-items/sprite-main/comment-bubble-85d8b2f44690f0a8e971e23309d62603.svg";